import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import { CarouselModalComponent } from '@valk-nx/components/ui-carousel-modal/src/lib/carousel-modal';
import type { PhotoInterface } from '@valk-nx/core/lib/interfaces/image.interface';

import type { OverlayCount } from './image-grid-cell/image-grid-cell';
import { ImageGridCellComponent } from './image-grid-cell/image-grid-cell';

const MAX_VISIBLE_IMAGES = 4;

@Component({
	selector: 'vp-image-grid',
	templateUrl: './image-grid.html',
	imports: [CarouselModalComponent, ImageGridCellComponent, NgTemplateOutlet],
})
export class ImageGridComponent {
	readonly images = input<PhotoInterface[]>([]);

	protected readonly visibleImages = computed(() =>
		this.images().slice(0, MAX_VISIBLE_IMAGES),
	);

	/** The overlay badge counts the hidden photos, its label the whole set. */
	protected readonly overlayCount = computed<OverlayCount | undefined>(() => {
		const total = this.images().length;

		return total > MAX_VISIBLE_IMAGES
			? { total, hidden: total - MAX_VISIBLE_IMAGES }
			: undefined;
	});
}
